import Rete from 'rete';
import LabelTextArea from "./components/LabelTextArea";

export class LabelTextAreaControl extends Rete.Control {

    static get DEFAULT_VALUE() { return ""; };

    constructor(editor, key, node, readonly = false, labelText) {
        super(key);
        // this.render = 'react'; // required?
        this.key = key;
        this.component = props => (
            <LabelTextArea {...props} />
        );

        const initial = node.data[key] || LabelTextAreaControl.DEFAULT_VALUE;
        node.data[key] = initial;

        this.props = {
            readonly,
            editor,
            value: initial,
            // putData: (key: string, data: unknown) => this.putData(key, data),
            putData: (data) => this.putData(this.key, data),
            labelText: labelText,
        };
    }
}